import { render, staticRenderFns } from "./SamBanner.vue?vue&type=template&id=46b465a5&scoped=true&shadow"
import script from "./SamBanner.vue?vue&type=script&lang=js&shadow"
export * from "./SamBanner.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamBanner.vue?vue&type=style&index=0&id=46b465a5&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "46b465a5",
  null
  ,true
)

export default component.exports